/**
 * NivX Machines — social handles / contact links.
 *
 * Change these values here and every icon on the site updates. All links
 * open in a new tab. Set a URL to `null` to hide that icon site-wide.
 *
 * WhatsApp shortlink format: `https://wa.me/<countrycode><number>`
 *   → Real number: `https://wa.me/919876543210` (no `+`, no spaces).
 *   → Business "click-to-chat" code: `https://wa.me/message/XXXXX`.
 *
 * X / Twitter, LinkedIn, GitHub, YouTube, Instagram, Facebook use their
 * standard public profile URLs.
 */
export const SOCIALS = {
  whatsapp: "https://wa.me/message/nivxmachines",   // TODO: replace with real number or WA-business click-to-chat code
  twitter:  "https://x.com/nivxmachines",           // TODO: create/verify handle
  linkedin: "https://www.linkedin.com/company/nivxmachines", // TODO: create company page or use existing slug
  github:   null,     // e.g. "https://github.com/nivxmachines"
  youtube:  null,
  instagram:null,
  facebook: null,
  email:    "mailto:contact@nivxmachines.com",
  website:  "https://nivxmachines.com",
};
